import React from "react";
import type { ShopEntity } from "../../../../../../domain/types/company-shop";

interface PreviewConsultFloatingProps {
  shopEntityData: ShopEntity | null;
  /** 데스크톱은 화면에 고정, 모바일은 전체 상품 아래 인라인으로 붙는다 */
  variant: "desktop" | "mobile";
}

export const PreviewConsultFloating = ({
  shopEntityData,
  variant,
}: PreviewConsultFloatingProps) => {
  if (!shopEntityData || shopEntityData.consultChannelType === "NONE") {
    return null;
  }

  const iconSrc =
    shopEntityData.consultChannelType === "KAKAO_CHANNEL"
      ? "/assets/icons/kakao-icon.svg"
      : "/assets/logo/channel-talk.png";
  const iconAlt =
    shopEntityData.consultChannelType === "KAKAO_CHANNEL"
      ? "카카오 채널 아이콘"
      : "채널톡 아이콘";

  if (variant === "desktop") {
    // h-[0] 이라 실제로 그려지지 않는 위치 기준용 요소다. bg-black 은 보이지 않는다
    return (
      <div className="hidden xl:block absolute h-[0] right-[70px] w-3 top-0 bg-black">
        <div className="fixed z-50 bottom-[20px] w-[60px] h-[60px]">
          <img className="rounded-2xl" src={iconSrc} alt={iconAlt} />
        </div>
      </div>
    );
  }

  return (
    <div className="xl:hidden px-[20px] flex justify-end pb-[20px]">
      <img
        className="rounded-2xl w-[60px] h-[60px]"
        src={iconSrc}
        alt={iconAlt}
      />
    </div>
  );
};
